var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmationModal',{attrs:{"bodyText":'',"cancelText":'',"enableMainAction":_vm.hasItemChanged,"handleCancel":_vm.handleCancel,"handleContinue":_vm.handleSave,"headerText":_vm.headerText,"kbLink":_vm.$options.kbLink,"mainActionAttention":false}},[_c('CertificateSettings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }